<template>
  <el-tabs type="border-card">
    <el-tab-pane label="门店管理">
      <companyList></companyList>
    </el-tab-pane>
    <el-tab-pane label="待审核门店">
      <companyAuditList></companyAuditList>
    </el-tab-pane>
  </el-tabs>

</template>
<script>
  import companyList from '@/pages/storeManagement/list/index.vue';
  import companyAuditList from '@/pages/storeManagement/listCreate/index.vue';

  export default {
    components:{companyAuditList,companyList}
    
  }
</script>